var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission"},[_c('div',{staticClass:"permission-wrap"},[_c('img',{staticClass:"permission-wrap-img",attrs:{"src":require("@/assets/img/no_permission.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"permission-wrap-text"},[_vm._v("您访问的当前页面暂无权限，请联系管理员开通权限")])])])
}]

export { render, staticRenderFns }